import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/MyContext";
import Shape from "./BsaicShape";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";

const BasicShapesContainer = (props) => {
  const [ShowItems, setShowItems] = useState(false);
  const { authenticationData } = useContext(AuthContext);

  const ImageUploderRef = useRef(null);
  const [MyLoader, setMyLoader] = useState(false);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const showUploadedScenes = (e) => {
    //setShowBasicShapes(!ShowBasicShapes);
    //console.log(e.currentTarget.id);
  };

  useEffect(() => { }, []);

  const imageUpload = () => {
    ImageUploderRef.current.click();
  };

  const fileChangeHandle3 = (e) => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    var formdata = new FormData();

    for (var i = 0; i < e.target.files.length; i++) {
      formdata.append("file", e.target.files[i]);
    }

    //console.log(e.target.files);
    formdata.append("CategoryId", props.item.id);

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Shapes/UploadShapes",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        alert(response.data.result);
      })
      .catch((excetion) => { });
  };

  return (
    <>
      <div className="CharacterShow2">
        <div className="character_container" style={{ background: "#ffffff" }}>
          <div className="character_container_insider">
            <div className="Chr_cont_folder">
              <div className="chr_cont_name">{props.item.name}</div>

              <div
                className="Chr_folder_insider"
                id={props.item.id}
                onClick={(e) => props.getShapesByCategory(e)}
              >
                <span className="maskclas" style={{ background: "#ffffff" }} />
                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  src={
                    authenticationData.ApiBaseURL +
                    "/" +
                    props.item.categoryPreviewImg
                  }
                  alt=""
                />
              </div>

              <div
                className="folderExpand"
                id={props.item.id}
                onClick={(e) => props.getShapesByCategory(e)}
              >
                {props.ShowBasicShapes && (
                  <span
                    style={{ top: "7px", fontSize: "12px", fontWeight: "600" }}
                    className="material-icons folderExpand_icon"
                  >
                    close
                  </span>
                )}
                {!props.ShowBasicShapes && (
                  <span
                    style={{
                      top: "9px",
                      right: "12px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    className="material-icons folderExpand_icon"
                  >
                    expand_more
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {props.ShowBasicShapes && (
        <div className="Character_folder_items">
          <div className="chr_cont_name text-center">Showing results for:</div>
          <div style={{ width: "100%", height: "auto" }}>
            <div className="seperator">
              <div className="Char_assetsList">
                <div className="image_uploader">
                  <div onClick={imageUpload} className="image_uploader_inner">
                    <div className="Image_uploader_text">
                      <div>Upload Image</div>
                      <input
                        ref={ImageUploderRef}
                        type="file"
                        multiple
                        hidden
                        onChange={fileChangeHandle3}
                        accept=".svg"
                      ></input>
                    </div>
                  </div>
                </div>

                {props.BasicShapes.map((shape, index) => {
                  if (props.item.id == shape.categoryId) {
                    return (
                      <Shape
                        id={shape.id}
                        key={index}
                        dataItem="item-1"
                        reletivePath={shape.shapePath}
                        url={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                        picurl={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                      />
                    );
                  }
                })}

                {/* <div className="column1">
                  {BasicShapes.slice(0, 17).map((shape, index) => {
                    return (
                      <Shape
                        key={index}
                        dataItem="item-1"
                        reletivePath={shape.shapePath}
                        url={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                        picurl={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                      />
                    );
                  })}
                </div>
                <div className="column2">
                  {BasicShapes.slice(18, 34).map((shape, index = 30) => {
                    return (
                      <Shape
                        key={index}
                        dataItem="item-1"
                        reletivePath={shape.shapePath}
                        url={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                        picurl={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                      />
                    );
                  })}
                </div>

                <div className="column3">
                  {BasicShapes.slice(35, 51).map((shape, index = 40) => {
                    return (
                      <Shape
                        key={index}
                        dataItem="item-1"
                        reletivePath={shape.shapePath}
                        url={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                        picurl={
                          authenticationData.ApiBaseURL + "/" + shape.shapePath
                        }
                      />
                    );
                  })}
                </div> */}

                {MyLoader == true && (
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: loader,
                    }}
                    height={200}
                    width={200}
                    isStopped={false}
                    isPaused={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default BasicShapesContainer;
